import { Dispatch, SetStateAction } from "react";
import Select from "../Select";

export type TourTypeFilter = "allTours" | "privateAvailable";

type TourTypeSelectorProps = {
  tourType: TourTypeFilter;
  setTourType: Dispatch<SetStateAction<TourTypeFilter>>;
};

export default function TourTypeSelector(props: TourTypeSelectorProps) {
  return (
    <Select<TourTypeFilter>
      sx={{ width: "220px", backgroundColor: "white" }}
      size="small"
      label="Tour Type"
      value={props.tourType}
      hideNone
      onChange={props.setTourType}
      options={[
        { id: "allTours", name: "All Tours" },
        { id: "privateAvailable", name: "Private tours available" },
      ]}
    />
  );
}
